import { createReducer, on } from '@ngrx/store';
import { CommunicationActions } from 'src/app/core/state/app.actions';
import { STATE_STATUS } from 'src/app/shared/models';
import { CommunicationState } from './communication.state';
import { StructureType } from 'addiction-components';

export const TAG = 'communication';

export interface FiltersType {
	structureUUID?: string;
	featureValue?: string[];
	communityUUID?: string;
	active?: boolean;
	updateDate?: string;
	communityEntityUUID?: string;
	[key: string]: unknown;
}

const initialState: CommunicationState = {
	filters: {
		featureValue: [],
		active: true,
		'structure.type': [StructureType.COMMUNICATION],
	},
	sort: undefined,
	pages: [0],
	data: { totalCommunicationsCount: 0, communications: [] },
	features: [],
	structures: [],
	status: STATE_STATUS.UNKNOWN,
	gridSearch: null,
	deleteStatus: 'unknown',
	cachedPages: [],
};

export const counterReducer = createReducer(
	initialState,
	/**
	 * Parte standard di un reducer
	 */
	on(CommunicationActions.setSort, (state: CommunicationState, { sort }) => ({
		...state,
		sort,
	})),
	on(CommunicationActions.setPages, (state: CommunicationState, { pages }) => ({
		...state,
		pages,
	})),
	on(CommunicationActions.setCommunicationsSuccess, (state: CommunicationState, { data }) => {
		return {
			...state,
			status: STATE_STATUS.READY,
			data: {
				communications: data.communications,
				totalCommunicationsCount: data.totalCommunicationsCount,
			},
			pages: data.pages,
		};
	}),
	on(CommunicationActions.setCommunicationsError, (state: CommunicationState) => ({
		...state,
		status: STATE_STATUS.ERROR,
	})),
	on(CommunicationActions.setStatus, (state: CommunicationState, { status }) => {
		return {
			...state,
			status,
		};
	}),
	on(CommunicationActions.setCachedPages, (state: CommunicationState, { pages }) => ({
		...state,
		cachedPages: [...new Set([...state.cachedPages, ...pages])],
	})),

	on(CommunicationActions.setGridSearch, (state: CommunicationState, { search }) => {
		return {
			...state,
			gridSearch: search,
		};
	}),
	on(CommunicationActions.setDeleteCommunications, (state: CommunicationState) => {
		return {
			...state,
			deleteStatus: STATE_STATUS.LOADING,
		};
	}),
	on(CommunicationActions.setDeleteCommunicationsSuccess, (state: CommunicationState) => {
		return {
			...state,
			deleteStatus: STATE_STATUS.READY,
		};
	}),
	on(CommunicationActions.setDeleteCommunicationsError, (state: CommunicationState) => {
		return {
			...state,
			deleteStatus: STATE_STATUS.ERROR,
		};
	}),
	on(CommunicationActions.setRecipients, (state: CommunicationState, { recipients }) => {
		return {
			...state,
			recipients: recipients,
		};
	}),
	/**
	 * PARTE SPECIFICA DEL REDUCER
	 */
	on(CommunicationActions.setFilters, (state: CommunicationState, { filters }) => ({
		...state,
		filters: {
			...filters,
			structureUUID: filters.structureUUID !== 'allStructures' ? filters.structureUUID : undefined,
			communityUUID: filters.communityEntityUUID,
		},
	})),
	on(CommunicationActions.setStructures, (state: CommunicationState, { structures }) => ({
		...state,
		structures,
	})),
	on(CommunicationActions.setFeatures, (state: CommunicationState, { features }) => ({
		...state,
		features,
	})),
	on(CommunicationActions.updateFilters, (state: CommunicationState, { updatedFilters }) => ({
		...state,
		filters: {
			...state.filters,
			...updatedFilters,
		},
	})),
	on(CommunicationActions.addFeatureValueToFilters, (state: CommunicationState, { featureValueUUID }) => ({
		...state,
		filters: {
			...state.filters,
			featureValue: state.filters.featureValue?.concat(featureValueUUID),
		},
	})),
	on(CommunicationActions.removeFeatureValueFromFilters, (state: CommunicationState, { featureValueUUID }) => ({
		...state,
		filters: {
			...state.filters,
			featureValue: state.filters.featureValue?.filter((uuid) => uuid !== featureValueUUID),
		},
	})),
	on(CommunicationActions.setForceRefreshCommunications, (state: CommunicationState) => ({
		...state,
		status: STATE_STATUS.FORCED_REFRESH,
	})),
	on(CommunicationActions.resetCache, (state: CommunicationState) => ({
		...state,
		status: STATE_STATUS.READY,
		cachedPages: [],
		pages: [0],
		data: {
			communications: [],
			totalCommunicationsCount: 0,
		},
	}))
);
